(() => {
  if (window.bsmCheckoutChoiceLoaded) return;
  window.bsmCheckoutChoiceLoaded = true;
  const routing = document.getElementById('BsmCheckoutRouting');
  const choicePage = document.querySelector('[data-bsm-choice-page]');
  const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
  const withPreview = (value) => {
    const url = new URL(value, window.location.origin);
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    return url.pathname + url.search;
  };
  if (choicePage) {
    document.querySelectorAll('[data-bsm-sign-in]').forEach((link) => {
      const auth = new URL(link.href);
      const returnUrl = new URL(auth.searchParams.get('return_to'), window.location.origin);
      if (previewTheme) returnUrl.searchParams.set('preview_theme_id', previewTheme);
      auth.searchParams.set('return_to', returnUrl.pathname + returnUrl.search);
      link.href = auth.pathname + auth.search;
    });
    const emailForm = choicePage.querySelector('[data-bsm-email-login]');
    if (emailForm) {
      const returnTo = emailForm.querySelector('[name="return_to"]');
      const newsletter = emailForm.querySelector('[name="marketing_consent"]');
      returnTo.value = withPreview(returnTo.value);
      const syncConsent = () => {
        choicePage.querySelectorAll('[data-bsm-provider]').forEach((link) => {
          const url = new URL(link.href);
          url.searchParams.set('marketing_consent', newsletter.checked ? 'true' : 'false');
          link.href = url.pathname + url.search;
        });
      };
      syncConsent();
      newsletter.addEventListener('change', syncConsent);
      emailForm.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!emailForm.reportValidity()) return;
        const url = new URL(emailForm.action);
        url.search = new URLSearchParams(new FormData(emailForm)).toString();
        url.searchParams.set('marketing_consent', newsletter.checked ? 'true' : 'false');
        window.location.assign(url.href);
      });
    }
    const autoForm = document.querySelector('[data-bsm-auto-checkout]');
    if (autoForm && !window.Shopify?.designMode) {
      autoForm.requestSubmit(autoForm.querySelector('[name="checkout"]'));
    }
  }
  if (!routing) return;
  const choiceUrl = () => withPreview(routing.dataset.choiceUrl);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-bsm-checkout-approved')) return;
    if (event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(choiceUrl());
    }
  }, true);
  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const buyNow = target.closest('[data-bsm-buy-now]');
    if (buyNow) {
      if (buyNow.disabled || buyNow.dataset.busy === 'true') return;
      const form = buyNow.form;
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      buyNow.dataset.busy = 'true';
      buyNow.disabled = true;
      buyNow.setAttribute('aria-busy', 'true');
      const productForm = form.closest('product-form');
      const errorWrapper = productForm?.querySelector('.product-form__error-message-wrapper');
      if (errorWrapper) errorWrapper.hidden = true;
      try {
        const response = await fetch(routing.dataset.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || routing.dataset.addError);
        window.location.assign(choiceUrl());
      } catch (error) {
        const message = productForm?.querySelector('.product-form__error-message');
        if (message && errorWrapper) {
          message.textContent = error.message || routing.dataset.addError;
          errorWrapper.hidden = false;
        }
        buyNow.disabled = !!form.querySelector('[name="add"]')?.disabled;
        delete buyNow.dataset.busy;
        buyNow.removeAttribute('aria-busy');
      }
      return;
    }
    const link = target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    if (link.hasAttribute('data-bsm-checkout-link') || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/i.test(url.pathname)) {
      event.preventDefault();
      window.location.assign(choiceUrl());
    }
  }, true);
  const bindBuyNow = () => {
    document.querySelectorAll('[data-bsm-buy-now]:not([data-bsm-bound])').forEach((button) => {
      const add = button.form?.querySelector('[name="add"]');
      if (!add) return;
      button.dataset.bsmBound = 'true';
      const sync = () => {
        if (button.dataset.busy !== 'true') button.disabled = add.disabled;
      };
      sync();
      new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled'] });
    });
  };
  bindBuyNow();
  document.addEventListener('shopify:section:load', bindBuyNow);
})();
